// 导入组件
import Vue from 'vue';
import Router from 'vue-router';
// 登录
import login from '@/views/login';
// 首页
import index from '@/views/index';
/**
 * 基础菜单
 */
// 系统首页
import baseIndex from '@/views/base/index';
// 用户管理
import Patient from '@/views/base/Patient';
// 科室管理
import Department from '@/views/base/Department';
// 医生管理
import Doctor from '@/views/base/Doctor';
// 挂号管理
import Registration from '@/views/base/Registration';
/**
 * 订单管理
 */
// 交易订单
import Order from '@/views/pay/Order';
// 对账管理
import Statement from '@/views/pay/Statement';
// 退费管理
import Refund from '@/views/pay/Refund';
// 支付宝对账
import Zfbdz from '@/views/pay/Zfbdz';
// 医保订单
import yborder from '@/views/pay/yborder'
/**
 * 系统管理
 */
// 用户管理
import user from '@/views/system/user';
// 角色管理
import Role from '@/views/system/Role';
// 公司管理
import Dept from '@/views/system/Dept';
// 系统环境变量
import Variable from '@/views/system/Variable';
// 权限管理
import Permission from '@/views/system/Permission';
// 调查管理
import Questions from '@/views/investigation/questions';
// 书记信箱
import sjxx from '@/views/investigation/sjxx';
// 院长信息
import yzxx from '@/views/investigation/yzxx';
// 日志管理
import log from '@/views/system/log';

/**
 * 在线问诊
 */
// 医生管理
import wzdoctor from '@/views/wenzhen/doctor';
// 医生排班
import paiban from '@/views/wenzhen/paiban';

/**
 * 新闻板块
 */
// 新闻管理
import articleList from '@/views/news/articleList';
// 新增、编辑新闻
import article from '@/views/news/article';

// 图表界面
import statistics from '@/views/charts/statistics';

/**
 * 支付管理
 */
// 支付配置信息
import MachineConfig from '@/views/machine/MachineConfig';
/**
 * 预约管理
 */
//检查预约
import inspect from '@/views/yuyue/inspect.vue'
//检验预约
import test from '@/views/yuyue/test.vue'

//核酸上报
import hssb from '@/views/hsjc/hssb.vue'


//核酸上报
import zzkdorder from '@/views/zzkd/orderlist.vue'

//更新科室
import updateDepartment from '@/views/base/updateDepartment';


//活动列表
import activelist from '@/views/active/activelist';
//专家信息
import zjinfolist from '@/views/active/zjinfolist';

// 启用路由
Vue.use(Router);

// 导出路由
export default new Router({
    mode:'history',
    routes: [{
        path: '/',
        name: '',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/login',
        name: '登录',
        component: login,
        hidden: true,
        meta: {
            requireAuth: false
        }
    }, {
        path: '/index',
        name: '首页',
        component: index,
        iconCls: 'el-icon-tickets',
        children: [{
            path: '/base/index',
            name: '系统首页',
            component: baseIndex,
            meta: {
                requireAuth: true
            }
        },{
            path: '/base/Patient',
            name: '用户信息',
            component: Patient,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/base/Department',
            name: '科室管理',
            component: Department,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/base/Doctor',
            name: '医生管理',
            component: Doctor,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/base/Registration',
            name: '挂号管理',
            component: Registration,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/pay/Order',
            name: '交易订单',
            component: Order,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/pay/Statement',
            name: '对账管理',
            component: Statement,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/pay/Zfbdz',
            name: '支付宝对账',
            component: Zfbdz,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/pay/Refund',
            name: '退费管理',
            component: Refund,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/pay/yborder',
            name: '医保订单',
            component: yborder,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/user',
            name: '用户管理',
            component: user,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Role',
            name: '角色管理',
            component: Role,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Dept',
            name: '公司管理',
            component: Dept,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Variable',
            name: '系统设置',
            component: Variable,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/Permission',
            name: '权限管理',
            component: Permission,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/investigation/questions',
            name: '问题管理',
            component: Questions,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/investigation/sjxx',
            name: '书记信息',
            component: sjxx,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/investigation/yzxx',
            name: '院长信箱',
            component: yzxx,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/machine/MachineConfig',
            name: '支付配置信息',
            component: MachineConfig,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/charts/statistics',
            name: '数据可视化',
            component: statistics,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/news/articleList',
            name: '新闻管理',
            component: articleList,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/news/article',
            name: '添加新闻',
            component: article,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/news/article/:id',
            name: '编辑新闻',
            component: article,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/system/log',
            name: '日志管理',
            component: log,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/wenzhen/wzdoctor',
            name: '问诊医生',
            component: wzdoctor,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/wenzhen/paiban',
            name: '医生排班',
            component: paiban,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/yuyue/inspect',
            name: '检查预约',
            component: inspect,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/yuyue/test',
            name: '检验预约',
            component: test,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/hsjc/hssb',
            name: '核酸上报',
            component: hssb,
            meta: {
                requireAuth: true
            }
        },
         {
            path: '/zzkd/orderlist',
            name: '订单列表',
            component: zzkdorder,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/base/updateDepartment',
            name: '挂号科室',
            component: updateDepartment,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/active/activelist',
            name: '活动列表',
            component: activelist,
            meta: {
                requireAuth: true
            }
        }, {
            path: '/active/zjinfolist',
            name: '专家信息',
            component: zjinfolist,
            meta: {
                requireAuth: true
            }
        }

        ]
    }]
})



// WEBPACK FOOTER //
// ./src/router/index.js